// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"remove-last-card_wrapper__2Rt0i","container":"remove-last-card_container__yyMyJ","card":"remove-last-card_card__htEb3","text":"remove-last-card_text__2CTrM"};